export default __webpack_public_path__ + "static/media/icon_quotes.e35d14fb.svg";